import { SetExternalScreenFilterAction, UserPreferences } from 'generated/sharedObjects/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';

/**
 * IA: http://lxsvnas401vm.ux.to2cz.cz/svn/arktika/Documentation/ARCHITECTURE/MNO/SharedObjects/1.0/attachements/
 * Swagger: http://lxsvnas401vm.ux.to2cz.cz/svn/arktika/Documentation/ARCHITECTURE/MNO/SharedObjects/1.0/resources/
 */
export const api = {
  /**
   * Gets session data for user session identified by JWT.
   */
  getSession: (url: string): Promise<ExtendedAxiosResponse> => apiClient.get(`${url}/session`),

  /**
   * Modifies currently logged user preferences.
   * @param url Base url for shared object microservice
   * @param userPreferencesData The user's preferences request data
   */
  setPreferences: (url: string, userPreferencesData: UserPreferences): Promise<ExtendedAxiosResponse> =>
    apiClient.patch(`${url}/preferences`, userPreferencesData),

  /**
   * Select a new status of external screen filter. Available only for users logged as internal users via JWT.
   * @param url Base url for shared object microservice
   * @param screenFilterData payload of the set external screen filter
   */
  setExternalScreenFilterAction: (
    url: string,
    screenFilterData: SetExternalScreenFilterAction
  ): Promise<ExtendedAxiosResponse> => apiClient.post(`${url}/setExternalScreenFilterAction`, screenFilterData),
};
